import React from 'react';
import { Control } from 'react-hook-form';
import { Button } from '@zurich-primitives/button';
import useInputGeneratorLabels from '../hooks/useInputGeneratorLabels';
import useInputGeneratorFields from '../hooks/useInputGeneratorFields';
import { AutocompleteControlledInput } from './autocompleteControlledInput';
import { FormFields } from '../IGPRScore.interface';
interface InputMedicalProblemProps {
  control: Control<FormFields>;
}

const fieldArrayName = 'problems';
export const InputMedicalProblem: React.FC<InputMedicalProblemProps> = ({
  control
}) => {
  const labelText = useInputGeneratorLabels(fieldArrayName);

  const { fields, append } = useInputGeneratorFields(control, fieldArrayName);

  return (
    <section id="medicalproblem-input">
      <h2 className="h2">{labelText}</h2>
      <div className="py-5">
        {fields.map((field, index) => (
          <AutocompleteControlledInput
            key={field.id}
            control={control}
            name={`${fieldArrayName}.${index}.value`}
            placeholder={labelText}
          />
        ))}
      </div>

      <Button
        className="body-sm-r"
        variant="tertiary"
        onClick={() => append({ value: '' })}
      >
        <Button.Label>+ Add</Button.Label>
      </Button>
    </section>
  );
};

export default InputMedicalProblem;
